import {
    IStatePointCollection, IStatePointEnum,
} from '@src/slide/application/service/slide-render-state/slide-render-state-manager.interface';
import AllThumbnailSiteStatePoint
    from '@src/slide/application/service/slide-render-state/state-point/all-thumbnail-site-state-point';
import FirstSlideRenderStatePoint
    from '@src/slide/application/service/slide-render-state/state-point/first-slide-render-state-point';
import VisibleSlideRenderStatePoint
    from '@src/slide/application/service/slide-render-state/state-point/visible-slide-render-state-point';
import AllSlideConvertStatePoint
    from '@src/slide/application/service/slide-render-state/state-point/all-slide-convert-state-point';
import EditSlideRenderStatePoint
    from '@src/slide/application/service/slide-render-state/state-point/edit-slide-render-state-point';

export function initStatePoints(): IStatePointCollection {
    return {
        // 首屏完成（移动端列表第一页、PC端编辑区）
        [IStatePointEnum.firstSlideRender]: new FirstSlideRenderStatePoint(),
        // 缩略图列表框完成
        [IStatePointEnum.allThumbnailSite]: new AllThumbnailSiteStatePoint(),
        // 可见区列表完成（移动端列表、PC端缩略图）
        [IStatePointEnum.visibleSlideRender]: new VisibleSlideRenderStatePoint(),
        // 所有slide转换完成
        [IStatePointEnum.allSlideConvert]: new AllSlideConvertStatePoint(),
        // 编辑区完成
        [IStatePointEnum.editSlideRender]: new EditSlideRenderStatePoint(),
    };
}
